<template>
  <div :id="data.menu_anchor" data-target class="menu-anchor" />
</template>

<script setup>
defineProps(['data'])

</script>
<style lang="scss" scoped>
.menu-anchor {
  @apply pt-[40px] mt-[-40px] xl:pt-[80px] xl:mt-[-80px] inline-block;
}
</style>
